import React, { useContext, useRef, useEffect, useMemo, useState } from 'react';
import { Hint } from '@flexiflow-ui-kit/hint';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import Select$1, { components } from 'react-select';
import { CloseIcon, ArrowDownIcon, CheckedIcon, SearchIcon } from '@flexiflow-ui-kit/icon';
import styled, { css } from 'styled-components';
import { Label } from '@flexiflow-ui-kit/label';
import { Spinner } from '@flexiflow-ui-kit/spinner';
import debounce from 'lodash.debounce';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function ClearIndicator(indicatorProps) {
  return /*#__PURE__*/React.createElement(components.ClearIndicator, indicatorProps, /*#__PURE__*/React.createElement(CloseIcon, {
    width: 10,
    height: 10
  }));
}

function DropdownIndicator(indicatorProps) {
  return /*#__PURE__*/React.createElement(components.DropdownIndicator, indicatorProps, /*#__PURE__*/React.createElement(ArrowDownIcon, {
    height: 5,
    width: 8
  }));
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject$3, _templateObject2$1, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var SelectContainer = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  ", ";\n  width: 100%;\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
});
var StyledSelect = styled(Select$1)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  pointer-events: all !important;\n\n  .", " {\n    &--is-disabled {\n      pointer-events: all;\n    }\n\n    &__control {\n      min-height: 32px;\n      transition: none;\n      border: 1px solid\n        ", ";\n      background-color: ", ";\n\n      font-size: 16px;\n      line-height: 20px;\n      cursor: ", ";\n      border-radius: 3px;\n\n      :hover {\n        border-color: ", ";\n        box-shadow: none;\n      }\n\n      [class$='-Input'] {\n        margin: 0;\n        padding: 0;\n        ", ";\n        position: relative;\n      }\n\n      &--is-focused {\n        box-shadow: none;\n        border-color: ", ";\n\n        [class$='-Input'] {\n          position: relative;\n        }\n\n        :hover {\n          border-color: ", ";\n        }\n      }\n    }\n\n    &__input-container {\n      position: relative;\n      padding: 0;\n      margin: 0;\n    }\n\n    &__value-container {\n      height: 100%;\n      padding: 5px 0 5px 8px;\n      min-height: 30px;\n      gap: 6px;\n\n      &--is-multi {\n        padding-right: 3px;\n        flex-wrap: ", ";\n      }\n\n      [class$='-DummyInput'] {\n        position: absolute;\n      }\n    }\n\n    &__placeholder {\n      color: ", ";\n      font-size: 16px;\n      line-height: 20px;\n      margin: 0;\n    }\n\n    &__indicators {\n      padding-right: 8px;\n      padding-left: 8px;\n    }\n\n    &__indicator {\n      padding: 4px;\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    }\n\n    &__single-value {\n      margin: 0;\n      font-size: 16px;\n      line-height: 20px;\n    }\n\n    &__multi-value {\n      margin: 0;\n      background-color: ", ";\n      border-radius: 12px;\n      font-size: 14px;\n      line-height: 16px;\n      min-height: 24px;\n      padding: 4px 8px;\n\n      &--is-disabled {\n        background-color: ", ";\n      }\n    }\n\n    &__multi-value__label {\n      font-size: 14px;\n      line-height: 16px;\n      color: ", ";\n      padding: 0;\n    }\n\n    &__multi-value__remove {\n      font-size: 14px;\n      line-height: 16px;\n      color: ", ";\n      padding: 0;\n      margin-left: 2px;\n\n      :hover {\n        background-color: ", ";\n        color: ", ";\n      }\n    }\n\n    &__input {\n      color: ", " !important;\n      font-size: 16px !important;\n      line-height: 20px !important;\n      position: absolute;\n      top: 0;\n      ", ";\n\n      input {\n        ", ";\n      }\n    }\n\n    &__menu {\n      margin: 4px 0;\n      border-radius: 4px;\n      width: 100%;\n      border: none;\n      background-color: ", ";\n      filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.1));\n      box-shadow: none;\n    }\n\n    &__menu-list {\n      border-radius: 4px;\n      border: none;\n      padding: 0;\n    }\n\n    &__option {\n      min-height: 32px;\n      padding: 6px 14px 6px 8px;\n      font-size: 16px;\n      line-height: 20px;\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      gap: 15px;\n      justify-content: space-between;\n      color: ", ";\n      background-color: ", ";\n      border: 0;\n\n      :first-child {\n        border-top-left-radius: 4px;\n        border-top-right-radius: 4px;\n      }\n\n      :last-child {\n        border-bottom-left-radius: 4px;\n        border-bottom-right-radius: 4px;\n      }\n\n      &:active {\n        background-color: ", ";\n      }\n\n      &--is-selected,\n      &--is-selected:active {\n        background-color: ", ";\n        color: ", ";\n      }\n\n      &--is-focused {\n        background-color: ", ";\n      }\n\n      &--is-disabled {\n        background: ", ";\n        color: ", ";\n        cursor: default;\n      }\n    }\n\n    &__group {\n      padding: 0;\n\n      :not(:last-child) {\n        margin-bottom: 5px;\n        border-bottom: 1px solid ", ";\n      }\n    }\n\n    &__group-heading {\n      color: ", ";\n      padding: 10px 12px 8px;\n      margin: 0;\n    }\n\n    &__menu-notice--no-options {\n      padding: 15px;\n    }\n\n    &__menu-notice {\n      color: ", ";\n      font-size: 14px;\n      line-height: 16px;\n    }\n  }\n"])), function (p) {
  return p.classNamePrefix;
}, function (p) {
  return p.isDisabled && p.theme.palette.gray['100'] || p.hasError && p.theme.palette.red['700'] || p.theme.palette.gray['400'];
}, function (p) {
  return p.isDisabled ? p.theme.palette.gray['100'] : p.theme.palette.white;
}, function (p) {
  return p.isDisabled ? 'not-allowed' : 'pointer';
}, function (p) {
  return p.isDisabled && p.theme.palette.gray['100'] || p.hasError && p.theme.palette.red['700'] || p.theme.palette.gray['400'];
}, function (p) {
  return !p.isMulti || p.multiValueInputPlaceholder ? 'width: 100%' : 'max-width: 100%';
}, function (p) {
  return p.hasError ? p.theme.palette.red['700'] : p.theme.palette.blue['500'];
}, function (p) {
  return p.hasError ? p.theme.palette.red['700'] : p.theme.palette.blue['500'];
}, function (p) {
  return p.multiValueInputPlaceholder ? 'nowrap' : 'wrap';
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.gray['400'];
}, function (p) {
  return p.theme.palette.gray['600'];
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.black;
}, function (p) {
  return !p.isMulti || p.multiValueInputPlaceholder ? css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n              width: 100% !important;\n            "]))) : css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n              max-width: 100%;\n            "])));
}, function (p) {
  return !p.isMulti || p.multiValueInputPlaceholder ? css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                width: 100% !important;\n              "]))) : css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n                max-width: 100%;\n              "])));
}, function (p) {
  return p.theme.palette.white;
}, function (p) {
  return p.theme.palette.black;
}, function (p) {
  return p.theme.palette.white;
}, function (p) {
  return p.theme.palette.white;
}, function (p) {
  return p.theme.palette.white;
}, function (p) {
  return p.theme.palette.black;
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['700'];
});
var StyledLabel = styled(Label)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin-bottom: 7px;\n"])));

var SelectContext = /*#__PURE__*/React.createContext({});

var _templateObject$2, _templateObject2;
styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  height: 18px;\n  min-height: 18px;\n  width: 22px;\n  font-size: 11px;\n  line-height: 13px;\n  flex-shrink: 0;\n  margin-right: 2px;\n  color: ", ";\n  background-color: ", ";\n"])), function (p) {
  return p.theme.palette.white;
}, function (p) {
  return p.theme.palette.gray['100'];
});
var Placeholder = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 14px;\n  line-height: 16px;\n"])), function (p) {
  return p.theme.palette.gray['100'];
});

var _excluded$5 = ["children"];
function ValueContainer(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$5);

  var _useContext = useContext(SelectContext),
      multiValueInputPlaceholder = _useContext.multiValueInputPlaceholder;

  var _props$selectProps = props.selectProps,
      placeholder = _props$selectProps.placeholder,
      isSearchable = _props$selectProps.isSearchable;
  return /*#__PURE__*/React.createElement(components.ValueContainer, props, multiValueInputPlaceholder && !isSearchable && placeholder && /*#__PURE__*/React.createElement(Placeholder, null, placeholder), children);
}

var _excluded$4 = ["innerRef"];
function Input(_ref) {
  var innerRef = _ref.innerRef,
      props = _objectWithoutProperties(_ref, _excluded$4);

  var _useContext = useContext(SelectContext),
      multiValueInputPlaceholder = _useContext.multiValueInputPlaceholder;

  var ref = useRef(null);
  var _ref2 = props,
      placeholder = _ref2.selectProps.placeholder;
  useEffect(function () {
    if (ref.current && multiValueInputPlaceholder && placeholder) {
      ref.current.placeholder = placeholder;
    }
  }, [placeholder, multiValueInputPlaceholder]);

  function setRef(element) {
    ref.current = element;
    innerRef === null || innerRef === void 0 ? void 0 : innerRef(element);
  }

  return /*#__PURE__*/React.createElement(components.Input, _extends({
    innerRef: setRef
  }, props, {
    isHidden: false
  }));
}

var _templateObject$1;
var InnerOptionContainer = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));

function Option(props) {
  var children = props.children,
      isSelected = props.isSelected;

  var _useContext = useContext(SelectContext),
      noCheckMarkForSelectedOption = _useContext.noCheckMarkForSelectedOption;

  return /*#__PURE__*/React.createElement(components.Option, props, /*#__PURE__*/React.createElement(InnerOptionContainer, null, children, ' ', !noCheckMarkForSelectedOption && isSelected && /*#__PURE__*/React.createElement(CheckedIcon, {
    width: 12,
    height: 9
  })));
}

function LoadingIndicator(indicatorProps) {
  return /*#__PURE__*/React.createElement(components.DropdownIndicator, indicatorProps, /*#__PURE__*/React.createElement(Spinner, {
    thickness: 1,
    radius: 8,
    color: "currentColor"
  }));
}

var _templateObject;
var LoadingMessageContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n"])));

function LoadingMessage() {
  return /*#__PURE__*/React.createElement(LoadingMessageContainer, null, /*#__PURE__*/React.createElement(Spinner, {
    thickness: 1,
    radius: 7,
    color: "currentColor"
  }), /*#__PURE__*/React.createElement("span", null, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."));
}

var _excluded$3 = ["value", "options", "onChange", "isMulti", "placeholder", "isClearable", "isSearchable", "hideSelectedOptions", "isDisabled", "hasError", "noOptionsMessage", "loadingMessage", "closeMenuOnSelect", "blurInputOnSelect", "menuPlacement", "maxMenuHeight", "label", "labelCanDisabled", "hint", "hintKeepPlace", "hintCanDisabled", "className", "components", "noCheckMarkForSelectedOption"];
function Select(props) {
  var value = props.value,
      options = props.options,
      onChange = props.onChange,
      isMulti = props.isMulti,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
      _props$isClearable = props.isClearable,
      isClearable = _props$isClearable === void 0 ? false : _props$isClearable,
      _props$isSearchable = props.isSearchable,
      isSearchable = _props$isSearchable === void 0 ? false : _props$isSearchable,
      _props$hideSelectedOp = props.hideSelectedOptions,
      hideSelectedOptions = _props$hideSelectedOp === void 0 ? false : _props$hideSelectedOp,
      isDisabled = props.isDisabled,
      hasError = props.hasError,
      _props$noOptionsMessa = props.noOptionsMessage,
      noOptionsMessage = _props$noOptionsMessa === void 0 ? function () {
    return 'Ничего не найдено';
  } : _props$noOptionsMessa,
      _props$loadingMessage = props.loadingMessage,
      loadingMessage = _props$loadingMessage === void 0 ? LoadingMessage : _props$loadingMessage,
      closeMenuOnSelectFromProps = props.closeMenuOnSelect,
      blurInputOnSelectFromProps = props.blurInputOnSelect,
      _props$menuPlacement = props.menuPlacement,
      menuPlacement = _props$menuPlacement === void 0 ? 'auto' : _props$menuPlacement,
      _props$maxMenuHeight = props.maxMenuHeight,
      maxMenuHeight = _props$maxMenuHeight === void 0 ? 250 : _props$maxMenuHeight,
      label = props.label,
      labelCanDisabled = props.labelCanDisabled,
      hint = props.hint,
      hintKeepPlace = props.hintKeepPlace,
      hintCanDisabled = props.hintCanDisabled,
      className = props.className,
      _props$components = props.components,
      componentsFromProps = _props$components === void 0 ? {} : _props$components,
      noCheckMarkForSelectedOption = props.noCheckMarkForSelectedOption,
      otherProps = _objectWithoutProperties(props, _excluded$3);

  var closeMenuOnSelect = closeMenuOnSelectFromProps === undefined ? !isMulti : closeMenuOnSelectFromProps;
  var blurInputOnSelect = blurInputOnSelectFromProps === undefined ? !isMulti : blurInputOnSelectFromProps;

  var componentsToRender = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, componentsFromProps), !componentsFromProps.IndicatorSeparator && {
    IndicatorSeparator: function IndicatorSeparator() {
      return null;
    }
  }), !componentsFromProps.DropdownIndicator && {
    DropdownIndicator: DropdownIndicator
  }), !componentsFromProps.ClearIndicator && {
    ClearIndicator: ClearIndicator
  }), !componentsFromProps.ValueContainer && {
    ValueContainer: ValueContainer
  }), !componentsFromProps.Input && {
    Input: Input
  }), !componentsFromProps.Option && {
    Option: Option
  }), !componentsFromProps.LoadingIndicator && {
    LoadingIndicator: LoadingIndicator
  });

  var multiValueInputPlaceholder = !!(isMulti && !componentsFromProps.MultiValue && placeholder);
  var contextValue = useMemo(function () {
    return {
      multiValueInputPlaceholder: multiValueInputPlaceholder,
      noCheckMarkForSelectedOption: noCheckMarkForSelectedOption
    };
  }, [multiValueInputPlaceholder, noCheckMarkForSelectedOption]);
  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(SelectContainer, {
    className: className
  }, /*#__PURE__*/React.createElement(Hint, {
    hasError: hasError,
    hint: hint,
    hintKeepPlace: hintKeepPlace,
    disabled: isDisabled,
    hintCanDisabled: hintCanDisabled
  }, /*#__PURE__*/React.createElement(StyledLabel, {
    hasError: hasError,
    label: label,
    disabled: isDisabled,
    labelCanDisabled: labelCanDisabled
  }), /*#__PURE__*/React.createElement(SelectContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(StyledSelect, _extends({
    classNamePrefix: "select",
    value: value,
    options: options,
    onChange: onChange,
    components: componentsToRender,
    placeholder: placeholder,
    isDisabled: isDisabled,
    isMulti: isMulti,
    isSearchable: isSearchable,
    isClearable: isClearable,
    maxMenuHeight: maxMenuHeight,
    closeMenuOnSelect: closeMenuOnSelect,
    blurInputOnSelect: blurInputOnSelect,
    menuPlacement: menuPlacement,
    hideSelectedOptions: hideSelectedOptions,
    noOptionsMessage: noOptionsMessage,
    loadingMessage: loadingMessage,
    hasError: hasError,
    multiValueInputPlaceholder: multiValueInputPlaceholder
  }, otherProps))))));
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ZoomDropdownIndicator(indicatorProps) {
  return /*#__PURE__*/React.createElement(components.DropdownIndicator, indicatorProps, /*#__PURE__*/React.createElement(SearchIcon, {
    height: 14,
    width: 14
  }));
}

var _excluded$2 = ["value", "onChange", "inputValue", "onInputChange", "loadOptions", "debounceTimeMs", "minQueryLengthToLoad", "noOptionsMessage", "noQueryLengthToLoadMessage", "onBlur", "tabSelectsValue"];
function BaseAsyncSelect(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      inputValue = _ref.inputValue,
      onInputChange = _ref.onInputChange,
      loadOptions = _ref.loadOptions,
      _ref$debounceTimeMs = _ref.debounceTimeMs,
      debounceTimeMs = _ref$debounceTimeMs === void 0 ? 250 : _ref$debounceTimeMs,
      _ref$minQueryLengthTo = _ref.minQueryLengthToLoad,
      minQueryLengthToLoad = _ref$minQueryLengthTo === void 0 ? 3 : _ref$minQueryLengthTo,
      noOptionsMessage = _ref.noOptionsMessage,
      _ref$noQueryLengthToL = _ref.noQueryLengthToLoadMessage,
      noQueryLengthToLoadMessage = _ref$noQueryLengthToL === void 0 ? function () {
    return 'Продолжайте печатать...';
  } : _ref$noQueryLengthToL,
      _onBlur = _ref.onBlur,
      _ref$tabSelectsValue = _ref.tabSelectsValue,
      tabSelectsValue = _ref$tabSelectsValue === void 0 ? false : _ref$tabSelectsValue,
      otherProps = _objectWithoutProperties(_ref, _excluded$2);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      options = _useState4[0],
      setOptions = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      query = _useState6[0],
      setQuery = _useState6[1];

  var prevQuery = useRef(query);
  var prevValue = useRef(value);

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showNoOptionsMessage = _useState8[0],
      setShowNoOptionsMessage = _useState8[1];

  var silentQueryUpdate = useRef(false);
  var currentRequestId = useRef(0);
  var setQueryDebounced = useMemo(function () {
    return debounce(setQuery, debounceTimeMs);
  }, [debounceTimeMs]); // TODO: sync query and inputValue (select option, backspace, select same option, backspace => no search)

  useEffect(function () {
    if (value !== prevValue.current) {
      prevValue.current = value;
      setShowNoOptionsMessage(false);
      return;
    }

    var valueLabel = (value === null || value === void 0 ? void 0 : value.label) || '';

    if (valueLabel === inputValue) {
      silentQueryUpdate.current = true;
      currentRequestId.current = 0;
      setQuery(valueLabel);
      setOptions([]);
      setIsLoading(false);
      setShowNoOptionsMessage(false);
      return;
    }

    silentQueryUpdate.current = false;
    setQueryDebounced(inputValue);
  }, [inputValue, setQueryDebounced, value, minQueryLengthToLoad]);
  useEffect(function () {
    var prevQueryValue = prevQuery.current;
    prevQuery.current = query;

    if (query === prevQueryValue) {
      return;
    }

    if (silentQueryUpdate.current) {
      silentQueryUpdate.current = false;
      return;
    }

    if (query.length < prevQueryValue.length) {
      setOptions([]);
      setShowNoOptionsMessage(false);
    }

    if (query.length < minQueryLengthToLoad) {
      setOptions([]);
      setShowNoOptionsMessage(true);
      setIsLoading(false);
      currentRequestId.current = 0;
      return;
    }

    if (query.length) {
      currentRequestId.current++;
    }

    var requestId = currentRequestId.current;

    function fetchOptions(_x) {
      return _fetchOptions.apply(this, arguments);
    }

    function _fetchOptions() {
      _fetchOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(str) {
        var loadedOptions;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return loadOptions(str);

              case 3:
                loadedOptions = _context.sent;

                if (requestId === currentRequestId.current) {
                  setOptions(loadedOptions);
                  setIsLoading(false);
                }

              case 5:
                _context.prev = 5;

                if (requestId === currentRequestId.current) {
                  setIsLoading(false);
                  currentRequestId.current = 0;
                }

                return _context.finish(5);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0,, 5, 8]]);
      }));
      return _fetchOptions.apply(this, arguments);
    }

    setIsLoading(true);
    setShowNoOptionsMessage(true);
    fetchOptions(query);
  }, [query, loadOptions, minQueryLengthToLoad]);
  return /*#__PURE__*/React.createElement(Select, _extends({
    tabSelectsValue: tabSelectsValue,
    isSearchable: true,
    value: value,
    onChange: function onChange() {
      _onChange.apply(void 0, arguments);

      setShowNoOptionsMessage(false);
    },
    onBlur: function onBlur(e) {
      setOptions([]);
      _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(e);
      setShowNoOptionsMessage(false);
    },
    isLoading: isLoading,
    inputValue: inputValue,
    components: _objectSpread2({
      SingleValue: function SingleValue() {
        return null;
      },
      DropdownIndicator: ZoomDropdownIndicator
    }, !options.length && {
      LoadingIndicator: function LoadingIndicator() {
        return null;
      }
    }),
    onInputChange: onInputChange,
    options: options,
    noOptionsMessage: showNoOptionsMessage ? query.length < minQueryLengthToLoad && noQueryLengthToLoadMessage || noOptionsMessage : function () {
      return null;
    },
    filterOption: function filterOption() {
      return true;
    }
  }, otherProps));
}

var _excluded$1 = ["value"];
function AsyncSelect(_ref) {
  var value = _ref.value,
      otherProps = _objectWithoutProperties(_ref, _excluded$1);

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  useEffect(function () {
    var newInputValue = value;
    setInputValue(newInputValue ? newInputValue.label : '');
  }, [value]);

  function onInputChange(newInputValue, _ref2) {
    var action = _ref2.action;

    if (action === 'input-change') {
      setInputValue(newInputValue);
    }

    if (action === 'input-blur') {
      setInputValue(value ? (value === null || value === void 0 ? void 0 : value.label) || '' : '');
    }
  }

  return /*#__PURE__*/React.createElement(BaseAsyncSelect, _extends({
    value: value,
    inputValue: inputValue,
    onInputChange: onInputChange
  }, otherProps));
}

var _excluded = ["value", "onChange"];
function AsyncCombobox(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      option = _useState2[0],
      setOption = _useState2[1];

  var prevOption = useRef(option);
  useEffect(function () {
    if (option === prevOption.current) {
      return;
    }

    onChange((option === null || option === void 0 ? void 0 : option.label) || '');
  }, [option, onChange]);

  function onInputChange(newInputValue, _ref2) {
    var action = _ref2.action;

    if (action === 'input-change') {
      onChange(newInputValue);
    }
  }

  return /*#__PURE__*/React.createElement(BaseAsyncSelect, _extends({
    value: option,
    onChange: setOption,
    inputValue: value,
    onInputChange: onInputChange,
    noCheckMarkForSelectedOption: true
  }, otherProps));
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function getPlaneSelectOptions(options) {
  return (options || []).reduce(function (allOptions, elem) {
    return [].concat(_toConsumableArray(allOptions), _toConsumableArray(elem.options ? elem.options : [elem]));
  }, []);
}

export { AsyncCombobox, AsyncSelect, Select, getPlaneSelectOptions };
